import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '@store/config';
import { Serie } from '@api/types.generated';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/serie');

export const fetchSerieList = actionCreator.async<{}, Serie[]>('SERIE_LIST');
export const createSerie = actionCreator.async<Omit<Serie, 'id'>, {}>('SERIE_CREATE');
export const deleteSerie = actionCreator.async<Serie['id'], {}>('SERIE_DELETE');
export const updateSerie = actionCreator.async<Serie, Serie>('SERIE_UPDATE');
